module.exports = __webpack_public_path__ + "static/media/order_img.d8ce3d74.jpg";